import useLocalStorage from './useLocalStorage'

export default function useAccess() {
  const { subscriptions, permissions, permissionsByStores, user } = useLocalStorage()

  const hasModuleBySlug = (slug: string) => {
    try {
      if (!subscriptions.value || typeof subscriptions.value !== 'object') {
        console.warn('hasModuleBySlug: subscriptions.value is not a valid object', subscriptions.value)
        return false
      }

      return subscriptions.value[slug]
    } catch (error) {
      console.error('hasModuleBySlug: Maximum call stack exceeded or other error', {
        slug,
        error: error.message,
        subscriptionsType: typeof subscriptions.value,
        subscriptionsValue: subscriptions.value
      })
      return false
    }
  }

  const hasPermissionBySlug = (slug: string) => {
    try {
      if (!permissions.value || typeof permissions.value !== 'object') {
        console.warn('hasPermissionBySlug: permissions.value is not a valid object', permissions.value)
        return false
      }

      const hasPermission = permissions.value[slug]
      if (slug.includes('promotional-code')) {
        return false
      } else {
        return hasPermission
      }
    } catch (error) {
      console.error('hasPermissionBySlug: Maximum call stack exceeded or other error', {
        slug,
        error: error.message,
        permissionsType: typeof permissions.value,
        permissionsValue: permissions.value
      })
      return false
    }
  }

  const hasMerchantModuleBySlug = (slug: string) => {
    if (slug === 'visual-identity') {
      return hasPermissionBySlug('global-configuration.read')
    }
    return true
  }

  const isDirection = computed(() => {
    return user.value?.roleTemplate?.slug === 'direction'
  })

  const updatePermissions = (data: any) => {
    permissions.value = {}
    permissionsByStores.value = {}

    permissions.value = userMergePermissions(data)
    permissionsByStores.value = data
  }

  const userMergePermissions = (permissions: any) => {
    const newPermissions = {}
    const permissionsArray = Object.values(permissions)
    permissionsArray.forEach((permissions) => {
      Object.keys(permissions).forEach((permission) => {
        if (!Object.keys(newPermissions).find((p) => p === permission)) {
          newPermissions[permission] = true
        }
      })
    })
    return newPermissions
  }

  const userMergeSubscriptions = (subscriptions: any) => {
    const newSubscriptions = {}
    const subscriptionsArray = Object.values(subscriptions)
    subscriptionsArray.forEach((subscriptions: Array<any>) => {
      subscriptions.forEach((subscription) => {
        if (!Object.keys(newSubscriptions).find((p) => p === subscription)) {
          newSubscriptions[subscription] = true
        }
      })
    })
    return newSubscriptions
  }

  /**
   * Merges module slugs from API response shape:
   * { "19": ["e-reputation", "dashboard", ...], "21": ["e-reputation"], ... }
   * Returns a single record of all unique slugs: { "e-reputation": true, "dashboard": true, ... }
   */
  const userMergeModules = (modules: Record<string, string[]>) => {
    const newModules: Record<string, boolean> = {}
    const modulesArray = Object.values(modules ?? {})
    modulesArray.forEach((moduleList) => {
      if (!Array.isArray(moduleList)) return
      moduleList.forEach((slug) => {
        if (slug && !(slug in newModules)) {
          newModules[slug] = true
        }
      })
    })
    return newModules
  }

  return {
    hasModuleBySlug,
    hasPermissionBySlug,
    hasMerchantModuleBySlug,
    userMergePermissions,
    updatePermissions,
    userMergeSubscriptions,
    userMergeModules,
    isDirection
  }
}
